// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ca5f8367","489":"695061c6","568":"22733fbd","802":"395d470f","943":"93d0d23e"}[chunkId] + ".chunk.js";
};